export const CAT_CARD_MENU_CRITERIA_COUNTRY = { US: 'US', CA: 'CA' };
export const CAT_CARD_MENU_CRITERIA_LANG_ID = {
  en_US: 'en_US',
  fr_FR: 'fr_FR'
};
export const CAT_CARD_MENU_FRENCH_TITLE = 'La Carte Cat';

export const CAT_MERCHANDISE_COUNTRY_LIST = ['US', 'CA', 'MX'];

export const CAT_MERCHANDISE = {
  title: 'Cat® Merchandise',
  seoUrl: 'https://shopcaterpillar.com'
};
